import React, { useEffect, useState, useRef } from "react";
import { RetellWebClient } from "retell-client-js-sdk";

// Add Google Fonts import for Poppins
const poppinsFontLink = document.createElement('link');
poppinsFontLink.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@600&display=swap';
poppinsFontLink.rel = 'stylesheet';
document.head.appendChild(poppinsFontLink);

const agentId = "agent_79f33cf88e6df9929decc21341";
const retellWebClient = new RetellWebClient();

const RiseWellTherapyButton = () => {
  const [isCalling, setIsCalling] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const debounceTimeout = useRef<number | null>(null);

  // Force transparent background on all ancestors
  useEffect(() => {
    const originalBodyBg = document.body.style.background;
    const originalHtmlBg = document.documentElement.style.background;
    const root = document.getElementById('root');
    const originalRootBg = root ? root.style.background : '';
    const originalBodyMargin = document.body.style.margin;
    const originalHtmlMargin = document.documentElement.style.margin;
    const originalRootMargin = root ? root.style.margin : '';

    document.body.style.background = "transparent";
    document.documentElement.style.background = "transparent";
    if (root) root.style.background = "transparent";
    document.body.style.margin = "0";
    document.documentElement.style.margin = "0";
    if (root) root.style.margin = "0";

    return () => {
      document.body.style.background = originalBodyBg;
      document.documentElement.style.background = originalHtmlBg;
      if (root) root.style.background = originalRootBg;
      document.body.style.margin = originalBodyMargin;
      document.documentElement.style.margin = originalHtmlMargin;
      if (root) root.style.margin = originalRootMargin;
    };
  }, []);

  useEffect(() => {
    retellWebClient.on("call_started", () => setIsCalling(true));
    retellWebClient.on("call_ended", () => {
      setIsCalling(false);
      setIsLoading(false);
    });
    retellWebClient.on("error", () => {
      retellWebClient.stopCall();
      setIsCalling(false);
      setIsLoading(false);
    });
  }, []);

  async function registerCall(agentId) {
    const response = await fetch("https://demo.braincx.ai:8080/create-web-call", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ agent_id: agentId })
    });
    if (!response.ok) throw new Error(`Error: ${response.status}`);
    return await response.json();
  }

  // Debounce function to prevent rapid clicks
  const debounce = (func, delay) => {
    return (...args) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = window.setTimeout(() => func(...args), delay);
    };
  };

  // Toggle conversation with debounce (matches ClassWallet/Gracehill)
  const toggleConversationDebounced = debounce(async () => {
    if (isLoading && !isCalling) return; // Prevent multiple calls while loading, but allow stop
    setIsLoading(true);

    if (isCalling) {
      retellWebClient.stopCall();
      setIsCalling(false);
      setIsLoading(false);
    } else {
      try {
        const registerCallResponse = await registerCall(agentId);
        if (registerCallResponse.access_token) {
          await retellWebClient.startCall({
            callId: registerCallResponse.call_id, accessToken: registerCallResponse.access_token, transport: registerCallResponse.transport, iceServers: registerCallResponse.ice_servers,
          });
          setIsCalling(true);
        }
      } catch (error) {
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    }
  }, 300);

  return (
    <button
      style={{
        padding: "1rem 2rem",
        fontSize: "1rem",
        fontWeight: 600,
        fontFamily: "'Poppins', sans-serif",
        borderRadius: "30px",
        border: "none",
        background: isCalling ? "#61A0C2" : "#61A0C2",
        color: "#fff",
        cursor: isLoading && !isCalling ? "not-allowed" : "pointer",
        boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
        outline: "none",
        transition: "background 0.2s, transform 0.2s",
        minWidth: "180px",
        letterSpacing: "1px"
      }}
      onClick={toggleConversationDebounced}
      disabled={isLoading && !isCalling}
    >
      {isCalling ? "Stop Demo" : "CONTACT VIXA"}
    </button>
  );
};

export default RiseWellTherapyButton;
